import React, { useState, useEffect, useRef } from 'react';
import { FaHeart, FaAward, FaTrophy } from 'react-icons/fa';
import './About.css';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="about" className="about section" ref={sectionRef}>
      <div className="container">
        <div className={`about-header ${isVisible ? 'fade-in' : ''}`}>
          <div className="title-section">
            <h2 className="heading-lg">
              מי <span className="gradient-text highlight-yellow">אני</span>?
            </h2>
            <div className="floating-badges">
              <div className="badge badge-1">
                <FaHeart />
                <span>8 שנות נסיון</span>
              </div>
              <div className="badge badge-2">
                <FaAward />
                <span>מקצועיות</span>
              </div>
              <div className="badge badge-3">
                <FaTrophy />
                <span>תוצאות מוכחות</span>
              </div>
            </div>
          </div>
        </div>

        <div className="about-content">
          <div className={`about-text ${isVisible ? 'fade-in' : ''}`}>
            <div className="story-content">
              <p className="intro-text">
                ליהי שירזי - מומחית שיווק דיגיטלי ומנהלת רשתות חברתיות.
              </p>
              
              <p className="story-paragraph">
                ליהי שירזי, בעלת <span className="highlight-text">8 שנות ניסיון מוכח</span> בתחום השיווק הדיגיטלי והרשתות החברתיות. 
                התמחותי החלה בגיל צעיר כאשר השתתפתי במחזור הראשון של האינסטקדמי של דנה זרמון, 
                שם רכשתי את הכלים המקצועיים הראשונים ופיתחתי את התשוקה למקצוע.
              </p>

              <div className="expertise-section">
                <h4 className="story-subtitle">תחומי התמחות</h4>
                <p className="story-paragraph">
                  במהלך השנים ניהלתי בהצלחה מגוון רחב של פרויקטים דיגיטליים בתחומים מגוונים:
                </p>
                <ul className="expertise-list">
                  <li>מסעדנות ותחום הקולינריה</li>
                  <li>אופנה ולייף סטייל</li>
                  <li>קונדיטוריה ומאפיות בוטיק</li>
                  <li>מוצרי צריכה וכלי בית</li>
                  <li>וולנס וכושר</li>
                  <li>אירועים</li>
                  <li>קוסמטיקה ויופי</li>
                  <li>ניהול אישי</li>
                  <li>בניית תדמית לאישי ציבור ופרסונות ברשת</li>
                </ul>
              </div>

              <div className="military-story">
                <h4 className="story-subtitle">ניסיון ייחודי בשירות הציבור</h4>
                <p className="story-paragraph">
                  במהלך השירות הצבאי בתפקיד ראש לשכת סגן אלוף, יזמתי והובלתי פרויקט דיגיטלי חדשני 
                  שהוכיח את הכוח של התקשורת הדיגיטלית בארגונים גדולים.
                </p>
                
                <p className="story-paragraph">
                  הפרויקט הצליח להעלות מורל בזמנים קשים, לחזק את הקשר בין היחידה למשפחות החיילים, 
                  ולשפר את התקשורת הפנימית והחיצונית של הארגון.
                </p>

                <p className="story-paragraph special-highlight">
                  ההצלחה הובילה לפתיחת תקן מילואים מיוחד, המאפשר לי להמשיך ולתרום 
                  לארגון גם לאחר השחרור הסדיר - שילוב ייחודי של שירות לציבור ותשוקה מקצועית.
                </p>
              </div>

              <div className="current-studies">
                <h4 className="story-subtitle">השקעה בהתפתחות מקצועית</h4>
                <p className="story-paragraph">
                  כחלק מהמחויבות להצטיינות מקצועית, אני לומדת תואר ראשון במנהל עסקים, עם התמחות בשיווק, פרסום ודיגיטל, 
                  תוך שילוב הניסיון המעשי עם הידע האקדמי המתקדם.
                </p>
              </div>

              <div className="stats-grid">
                <div className="stat-item">
                  <div className="stat-number">8+</div>
                  <div className="stat-label">שנות ניסיון</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">100+</div>
                  <div className="stat-label">פרויקטים מוצלחים</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">50+</div>
                  <div className="stat-label">לקוחות מרוצים</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;